import React from 'react';
import { BrowserRouter, HashRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, Box } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import { glassmorphismTheme } from './theme/glassmorphism';
import { AdminProvider } from './contexts/AdminContext';
import Navbar from './components/Layout/Navbar';
import WhatsAppButton from './components/WhatsAppButton';
import Home from './pages/Home';
import Services from './pages/Services';
import BookSlot from './pages/BookSlot';
import Contact from './pages/Contact';
import Kundali from './pages/Kundali';
import KundaliMatching from './pages/KundaliMatching';
import RashiPhal from './pages/RashiPhal';
import Consultation from './pages/Consultation';
import AdminDashboard from './pages/AdminDashboard';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Footer from './components/Footer';

function App() {
  const isNativeShell =
    window.location.protocol === 'capacitor:' ||
    window.location.protocol === 'ionic:' ||
    Boolean((window as Window & { Capacitor?: unknown }).Capacitor);

  const RouterComponent = isNativeShell ? HashRouter : BrowserRouter;

  return (
    <ThemeProvider theme={glassmorphismTheme}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <AdminProvider>
          <CssBaseline />
          <Box
            sx={{
              minHeight: '100vh',
              backgroundColor: '#FFFAF5',
            }}
          >
          <RouterComponent>
            <Routes>
              {/* Main website routes with navbar */}
              <Route path="/" element={
                <>
                  <Navbar />
                  <Home />
                  <Footer />
                </>
              } />
              <Route path="/services" element={
                <>
                  <Navbar />
                  <Services />
                  <Footer />
                </>
              } />
              <Route path="/book-slot" element={
                <>
                  <Navbar />
                  <BookSlot />
                  <Footer />
                </>
              } />
              <Route path="/contact" element={
                <>
                  <Navbar />
                  <Contact />
                  <Footer />
                </>
              } />
              <Route path="/kundali" element={
                <>
                  <Navbar />
                  <Kundali />
                  <Footer />
                </>
              } />
              <Route path="/kundali-matching" element={
                <>
                  <Navbar />
                  <KundaliMatching />
                  <Footer />
                </>
              } />
              <Route path="/rashi-phal" element={
                <>
                  <Navbar />
                  <RashiPhal />
                  <Footer />
                </>
              } />
              <Route path="/consultation" element={
                <>
                  <Navbar />
                  <Consultation />
                  <Footer />
                </>
              } />
              <Route path="/terms" element={
                <>
                  <Navbar />
                  <Terms />
                  <Footer />
                </>
              } />
              <Route path="/privacy" element={
                <>
                  <Navbar />
                  <Privacy />
                  <Footer />
                </>
              } />
              
              {/* Admin route — handles its own auth, navbar, footer */}
              <Route path="/admin" element={<AdminDashboard />} />
            </Routes>
            <WhatsAppButton />
          </RouterComponent>
        </Box>
        </AdminProvider>
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default App;
